import styled from "styled-components";
import Typography from "./typography";
import Button from "./button";
import { NASTYGREEN, BROWNISHGREY } from "./colors";
import { TABLET } from "./constants";

export const LoginWrapper = styled.div`
  padding: 60px 0;
`;

export const LoginForm = styled.form`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  margin: 0 auto;
  width: 460px;
  background: white;
  box-shadow: 0px 6px 30px 0px rgba(26, 26, 26, 0.18);
  padding: 35px 60px;
  border-radius: 10px;
  @media (max-width: ${TABLET}px) {
    width: 300px;
    padding: 35px;
  }
`;

export const LoginFormTitle = styled(Typography)`
  color: ${BROWNISHGREY};
  font-weight: 700;
  margin-bottom: 27px;
  font-size: 20px;
  width: 100%;
  text-align: center;
`;

export const LoginError = styled(Typography)`
  font-size: 14px;
  color: red;
`;

export const LoginButton = styled(Button)`
  background-color: ${NASTYGREEN}
  padding: 16px;
  width: 250px;
  color: white;
  text-transform: uppercase;
  border-radius: 5px;
  margin-top: 18px;
  &:hover {
    opacity: 0.8;
  }
  &:active {
    opacity: 0.8;
    position: relative;
    top: 1px;
  }
  &:disabled {
    opacity: 0.5;
  }
  @media (max-width: ${TABLET}px) {
    width: 230px;
  }
`;

export const ForgotPasswordButton = styled(Button)`
  font-size: 14px;
  color: ${NASTYGREEN};
  margin-top: 7px;
  border: none;
  outline: none;
  cursor: pointer;
`;
